/* Soleyna Lou — Store Locator
 * Öffentlicher Händler-/Gastro-Finder für Lago Bianco (Raum Ansbach / Mittelfranken).
 * Datenquelle: JSON aus #sls-locations (via Liquid aus Metaobject soleyna_location, nur active=true,
 * NUR öffentliche Felder — keine internen Customer-Tags/Preise/Zuordnungsfelder).
 * Umkreissuche per Haversine. Geocoding zuerst lokal, bei unbekannten Orten auf ausdrückliche
 * Suche hin über OpenStreetMap Nominatim. Geolocation nur auf Klick.
 */
(function () {
  'use strict';
  var root = document.getElementById('sls-root');
  if (!root) return;

  /* Interne Region-Ortstabelle (echte Stadt-Koordinaten, nur zur Eingabe-Geocodierung) */
  var CITIES = [
    { name: 'Ansbach', plz: '91522', lat: 49.3033, lng: 10.5731 },
    { name: 'Merkendorf', plz: '91732', lat: 49.1997, lng: 10.7009 },
    { name: 'Nürnberg', plz: '90402', lat: 49.4521, lng: 11.0767 },
    { name: 'Rothenburg ob der Tauber', plz: '91541', lat: 49.3777, lng: 10.1789 },
    { name: 'Dinkelsbühl', plz: '91550', lat: 49.0706, lng: 10.3200 },
    { name: 'Gunzenhausen', plz: '91710', lat: 49.1147, lng: 10.7561 },
    { name: 'Feuchtwangen', plz: '91555', lat: 49.1683, lng: 10.3319 },
    { name: 'Schwabach', plz: '91126', lat: 49.3286, lng: 11.0208 },
    { name: 'Heilsbronn', plz: '91560', lat: 49.3389, lng: 10.7897 },
    { name: 'Windsbach', plz: '91575', lat: 49.2497, lng: 10.8283 },
    { name: 'Neuendettelsau', plz: '91564', lat: 49.2803, lng: 10.7889 },
    { name: 'Herrieden', plz: '91567', lat: 49.2372, lng: 10.5006 },
    { name: 'Leutershausen', plz: '91578', lat: 49.2953, lng: 10.4211 },
    { name: 'Bergtheim', plz: '97241', lat: 49.8744, lng: 10.0194 },
    { name: 'Würzburg', plz: '97070', lat: 49.7913, lng: 9.9534 },
    { name: 'Ebermannstadt', plz: '91320', lat: 49.7806, lng: 11.1836 },
    { name: 'Forchheim', plz: '91301', lat: 49.7186, lng: 11.0586 },
    { name: 'Bad Vilbel', plz: '61118', lat: 50.1786, lng: 8.7377 },
    { name: 'Frankfurt', plz: '60311', lat: 50.1109, lng: 8.6821 },
    { name: 'Fürstenzell', plz: '94081', lat: 48.5236, lng: 13.3197 },
    { name: 'Osterhofen', plz: '94486', lat: 48.6889, lng: 13.0197 },
    { name: 'Zwiesel', plz: '94227', lat: 49.0186, lng: 13.2378 },
    { name: 'Passau', plz: '94032', lat: 48.5667, lng: 13.4319 },
    { name: 'Deggendorf', plz: '94469', lat: 48.8339, lng: 12.9578 },
    { name: 'Regen', plz: '94209', lat: 48.9686, lng: 13.1289 },
    { name: 'Ingolstadt', plz: '85053', lat: 48.7665, lng: 11.4258 },
    { name: 'Pfarrkirchen', plz: '84347', lat: 48.4306, lng: 12.9436 },
    { name: 'Landshut', plz: '84036', lat: 48.5372, lng: 12.1517 }
  ];

  function norm(s) {
    return (s || '').toString().trim().toLowerCase()
      .replace(/ä/g, 'ae').replace(/ö/g, 'oe').replace(/ü/g, 'ue').replace(/ß/g, 'ss')
      .replace(/[^a-z0-9]/g, '');
  }

  function geocodeLocal(q) {
    q = (q || '').trim();
    if (!q) return null;
    var digits = q.replace(/\D/g, '');
    if (digits.length >= 3) {
      var exact = CITIES.filter(function (c) { return c.plz === digits; });
      if (exact.length) return exact[0];
      var pre = CITIES.filter(function (c) { return c.plz.slice(0, 3) === digits.slice(0, 3); });
      if (pre.length) return pre[0];
    }
    var nq = norm(q);
    if (!nq) return null;
    var hit = CITIES.filter(function (c) { return norm(c.name) === nq; })[0];
    if (hit) return hit;
    hit = CITIES.filter(function (c) { return nq.length >= 3 && norm(c.name).indexOf(nq) === 0; })[0];
    return hit || null;
  }

  function geocodeRemote(q) {
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 6000) : null;
    var url = 'https://nominatim.openstreetmap.org/search?format=jsonv2&limit=1&countrycodes=de&q=' +
      encodeURIComponent(q + ', Deutschland');
    return fetch(url, {
      headers: { 'Accept': 'application/json', 'Accept-Language': 'de' },
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('Geocoding fehlgeschlagen');
      return response.json();
    }).then(function (results) {
      if (!results || !results.length) return null;
      return {
        name: q,
        lat: parseFloat(results[0].lat),
        lng: parseFloat(results[0].lon)
      };
    }).catch(function () {
      return null;
    }).finally(function () {
      if (timer) clearTimeout(timer);
    });
  }

  function haversine(lat1, lng1, lat2, lng2) {
    var R = 6371, toR = function (x) { return x * Math.PI / 180; };
    var dLat = toR(lat2 - lat1), dLng = toR(lng2 - lng1);
    var s = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toR(lat1)) * Math.cos(toR(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(s), Math.sqrt(1 - s));
  }

  /* Daten laden */
  var data = [];
  try { data = JSON.parse(document.getElementById('sls-locations').textContent) || []; } catch (e) { data = []; }
  data = data.filter(function (l) { return l && isFinite(parseFloat(l.lat)); }).map(function (l) {
    l.lat = parseFloat(l.lat); l.lng = parseFloat(l.lng);
    l.tags = Array.isArray(l.tags) ? l.tags : (l.tags ? [l.tags] : []);
    l.title = (l.business_name && String(l.business_name).trim()) ? l.business_name : (l.name || 'Standort');
    return l;
  });

  /* Jeder neue Metaobjekt-Standort erweitert automatisch die lokale Ort-/PLZ-Suche. */
  data.forEach(function (l) {
    if (!l.city || !isFinite(l.lat) || !isFinite(l.lng)) return;
    var exists = CITIES.some(function (c) {
      return (l.zip && c.plz === String(l.zip)) || norm(c.name) === norm(l.city);
    });
    if (!exists) CITIES.push({ name: l.city, plz: String(l.zip || ''), lat: l.lat, lng: l.lng });
  });

  var elQ = document.getElementById('sls-q'),
      elRadius = document.getElementById('sls-radius'),
      elType = document.getElementById('sls-type'),
      elForm = document.getElementById('sls-form'),
      elResults = document.getElementById('sls-results'),
      elStatus = document.getElementById('sls-status'),
      elGeo = document.getElementById('sls-geo'),
      tagEls = [].slice.call(root.querySelectorAll('.sls-tag input'));
  var contactLink = root.getAttribute('data-contact') || '/pages/handel-gastro';
  var origin = null, originLabel = '';

  /* Karte (Leaflet + OpenStreetMap) */
  var elMap = document.getElementById('sls-map');
  var map = null, markerLayer = null, originMarker = null, radiusCircle = null, lastList = [];

  var IC = {
    pin: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s7-5.5 7-11a7 7 0 10-14 0c0 5.5 7 11 7 11z"/><circle cx="12" cy="10" r="2.5"/></svg>',
    phone: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 3h3l2 5-2.5 1.5a12 12 0 006 6L16 13l5 2v3a2 2 0 01-2 2A16 16 0 014 5a2 2 0 012-2z"/></svg>',
    globe: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3 12h18M12 3c2.6 2.7 2.6 15.3 0 18M12 3c-2.6 2.7-2.6 15.3 0 18"/></svg>',
    ig: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="3.5" width="17" height="17" rx="5"/><circle cx="12" cy="12" r="3.5"/><circle cx="17" cy="7" r="1"/></svg>',
    route: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 20V8a3 3 0 013-3h4"/><path d="M13 2l4 3-4 3"/><circle cx="6" cy="20" r="2"/></svg>'
  };

  function esc(s) {
    return (s == null ? '' : String(s)).replace(/[&<>"']/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
    });
  }

  function card(l) {
    var p = [];
    p.push('<article class="sls-card' + (l.featured ? ' sls-card--feat' : '') + '">');
    p.push('<div class="sls-card-top"><div class="sls-card-head">');
    if (l.demo) p.push('<span class="sls-badge sls-badge--demo">Demo</span>');
    if (l.featured) p.push('<span class="sls-badge sls-badge--star">Empfohlen</span>');
    p.push('<h3 class="sls-card-title">' + esc(l.title) + '</h3>');
    if (l.type) p.push('<p class="sls-card-type">' + IC.pin + '<span>' + esc(l.type) + '</span></p>');
    p.push('</div>');
    if (typeof l._dist === 'number') p.push('<span class="sls-dist"><strong>' + l._dist.toFixed(1).replace('.', ',') + '</strong> km</span>');
    p.push('</div>');
    if (l.tags && l.tags.length) {
      p.push('<div class="sls-tags-out">');
      l.tags.forEach(function (t) { p.push('<span class="sls-chip">' + esc(t) + '</span>'); });
      p.push('</div>');
    }
    p.push('<address class="sls-addr">');
    if (l.address) p.push(esc(l.address) + '<br>');
    p.push('<span class="sls-num">' + esc(((l.zip || '') + ' ' + (l.city || '')).trim()) + '</span>');
    if (l.region) p.push('<span class="sls-region">' + esc(l.region) + '</span>');
    p.push('</address>');
    if (l.hours) p.push('<p class="sls-hours">' + esc(l.hours).replace(/\n/g, '<br>') + '</p>');
    p.push('<div class="sls-card-actions">');
    var destination = ((l.address || '') + ', ' + (l.zip || '') + ' ' + (l.city || '') + ', Deutschland')
      .replace(/^,\s*|,\s*,/g, '').trim();
    var dest = encodeURIComponent(destination || (l.lat + ',' + l.lng));
    p.push('<a class="sls-btn sls-btn--primary" target="_blank" rel="noopener" href="https://www.google.com/maps/dir/?api=1&destination=' + dest + '">' + IC.route + 'Route planen</a>');
    if (l.website) p.push('<a class="sls-btn sls-btn--ghost" target="_blank" rel="noopener nofollow" href="' + esc(l.website) + '">' + IC.globe + 'Website</a>');
    if (l.instagram) p.push('<a class="sls-btn sls-btn--icon" target="_blank" rel="noopener nofollow" aria-label="Instagram-Profil" href="' + esc(l.instagram) + '">' + IC.ig + '</a>');
    if (l.phone) p.push('<a class="sls-btn sls-btn--icon" aria-label="Anrufen" href="tel:' + esc(String(l.phone).replace(/\s/g, '')) + '">' + IC.phone + '</a>');
    p.push('</div></article>');
    return p.join('');
  }

  function activeTags() { return tagEls.filter(function (c) { return c.checked; }).map(function (c) { return c.value; }); }

  /* ---- Karte ---- */
  function pinIcon(feat) {
    return L.divIcon({
      className: 'sls-mk sls-mk--pin' + (feat ? ' sls-mk--feat' : ''),
      iconSize: [28, 36], iconAnchor: [14, 35], popupAnchor: [0, -32],
      html: '<svg viewBox="0 0 24 32" width="28" height="36" xmlns="http://www.w3.org/2000/svg"><path d="M12 0C5.4 0 0 5.2 0 11.6 0 20 12 32 12 32s12-12 12-20.4C24 5.2 18.6 0 12 0z"/><circle cx="12" cy="11.5" r="4"/></svg>'
    });
  }
  function meIcon() {
    return L.divIcon({
      className: 'sls-mk sls-mk--me', iconSize: [24, 24], iconAnchor: [12, 12], popupAnchor: [0, -10],
      html: '<svg viewBox="0 0 24 24" width="24" height="24" xmlns="http://www.w3.org/2000/svg"><circle class="o" cx="12" cy="12" r="8"/><circle class="i" cx="12" cy="12" r="3"/></svg>'
    });
  }
  function popupHtml(l) {
    var dest = (l.lat && l.lng) ? (l.lat + ',' + l.lng) : encodeURIComponent(((l.address || '') + ' ' + (l.zip || '') + ' ' + (l.city || '')).trim());
    var h = '<p class="sls-pop-t">' + esc(l.title) + '</p>';
    if (l.type) h += '<p class="sls-pop-ty">' + esc(l.type) + '</p>';
    h += '<div>' + esc(((l.zip || '') + ' ' + (l.city || '')).trim()) + '</div>';
    if (typeof l._dist === 'number') h += '<p class="sls-pop-d">' + l._dist.toFixed(1).replace('.', ',') + ' km entfernt</p>';
    h += '<a href="https://www.google.com/maps/dir/?api=1&destination=' + dest + '" target="_blank" rel="noopener">Route planen ›</a>';
    return h;
  }
  function initMap() {
    if (map || !elMap || typeof L === 'undefined') return;
    map = L.map(elMap, { scrollWheelZoom: false, zoomControl: true }).setView([49.35, 10.75], 8);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '© OpenStreetMap-Mitwirkende' }).addTo(map);
    markerLayer = L.layerGroup().addTo(map);
  }
  function updateMap(list) {
    initMap();
    if (!map) return;
    markerLayer.clearLayers();
    if (originMarker) { map.removeLayer(originMarker); originMarker = null; }
    if (radiusCircle) { map.removeLayer(radiusCircle); radiusCircle = null; }
    var pts = [];
    (list || []).forEach(function (l) {
      if (!isFinite(l.lat) || !isFinite(l.lng)) return;
      L.marker([l.lat, l.lng], { icon: pinIcon(l.featured) }).bindPopup(popupHtml(l)).addTo(markerLayer);
      pts.push([l.lat, l.lng]);
    });
    if (origin) {
      originMarker = L.marker([origin.lat, origin.lng], { icon: meIcon(), zIndexOffset: 1000 }).addTo(map);
      originMarker.bindPopup('<p class="sls-pop-t">' + esc(originLabel || 'Dein Standort') + '</p>');
      pts.push([origin.lat, origin.lng]);
      var r = elRadius ? parseFloat(elRadius.value) : 0;
      if (r) { radiusCircle = L.circle([origin.lat, origin.lng], { radius: r * 1000, weight: 1 }).addTo(map); }
    }
    if (pts.length > 1) { try { map.fitBounds(pts, { padding: [38, 38], maxZoom: 13 }); } catch (e) {} }
    else if (pts.length === 1) { map.setView(pts[0], origin ? 11 : 12); }
    setTimeout(function () { if (map) map.invalidateSize(); }, 60);
  }

  function apply() {
    var type = elType ? elType.value : '';
    var tags = activeTags();
    var radius = (origin && elRadius) ? parseFloat(elRadius.value) : null;
    var list = data.slice();

    if (type && type !== 'Alle') list = list.filter(function (l) { return (l.type || '').toLowerCase() === type.toLowerCase(); });
    if (tags.length) list = list.filter(function (l) {
      var lt = (l.tags || []).map(function (x) { return x.toLowerCase(); });
      return tags.every(function (t) { return lt.indexOf(t.toLowerCase()) >= 0; });
    });

    if (origin) {
      list.forEach(function (l) { l._dist = haversine(origin.lat, origin.lng, l.lat, l.lng); });
      if (radius) list = list.filter(function (l) { return l._dist <= radius; });
      list.sort(function (a, b) { return a._dist - b._dist; });
    } else {
      list.forEach(function (l) { delete l._dist; });
      list.sort(function (a, b) { return (b.featured ? 1 : 0) - (a.featured ? 1 : 0) || String(a.title).localeCompare(b.title); });
    }
    render(list);
  }

  function render(list) {
    var label = origin && originLabel ? ' · Umkreis um ' + esc(originLabel) : '';
    elStatus.innerHTML = '<p class="sls-count"><strong class="sls-num">' + list.length + '</strong> ' + (list.length === 1 ? 'Standort' : 'Standorte') + label + '</p>';
    lastList = list; updateMap(list);
    if (!list.length) {
      elResults.innerHTML = '<div class="sls-empty"><p class="sls-empty-h">Keine Standorte gefunden</p><p>Für deine Auswahl gibt es aktuell keinen Standort. Erweitere den Umkreis oder den Typ – oder <a href="' + esc(contactLink) + '">kontaktiere uns direkt</a>.</p></div>';
      return;
    }
    elResults.innerHTML = list.map(card).join('');
  }

  function unknown() {
    elStatus.innerHTML = '';
    elResults.innerHTML = '<div class="sls-empty"><p class="sls-empty-h">Ort nicht erkannt</p><p>Bitte prüfe die Schreibweise von Stadt oder PLZ – oder <a href="' + esc(contactLink) + '">kontaktiere uns direkt</a>.</p></div>';
  }

  function setSearching(isSearching) {
    var button = elForm ? elForm.querySelector('.sls-btn--search') : null;
    if (!button) return;
    button.disabled = isSearching;
    button.textContent = isSearching ? 'Ort wird gesucht…' : 'Standorte suchen';
  }

  function doSearch() {
    var q = elQ ? elQ.value : '';
    var trimmed = q.trim();
    var g = geocodeLocal(trimmed);
    if (!trimmed) { origin = null; originLabel = ''; apply(); return; }
    if (g) {
      origin = { lat: g.lat, lng: g.lng }; originLabel = g.name;
      apply();
      return;
    }
    setSearching(true);
    geocodeRemote(trimmed).then(function (remote) {
      if (!remote) { origin = null; originLabel = ''; unknown(); return; }
      origin = { lat: remote.lat, lng: remote.lng }; originLabel = trimmed;
      apply();
    }).finally(function () { setSearching(false); });
  }

  if (elForm) elForm.addEventListener('submit', function (e) { e.preventDefault(); doSearch(); });
  if (elType) elType.addEventListener('change', apply);
  if (elRadius) elRadius.addEventListener('change', function () { if (origin) apply(); });
  tagEls.forEach(function (c) { c.addEventListener('change', apply); });

  /* Geolocation NUR nach Klick — keine automatische Standortabfrage */
  if (elGeo) {
    if (!('geolocation' in navigator)) { elGeo.style.display = 'none'; }
    elGeo.addEventListener('click', function () {
      if (!navigator.geolocation) return;
      elGeo.classList.add('is-loading'); elGeo.disabled = true;
      navigator.geolocation.getCurrentPosition(function (pos) {
        origin = { lat: pos.coords.latitude, lng: pos.coords.longitude }; originLabel = 'deinem Standort';
        if (elQ) elQ.value = '';
        elGeo.classList.remove('is-loading'); elGeo.disabled = false;
        apply();
      }, function () {
        elGeo.classList.remove('is-loading'); elGeo.disabled = false;
        elStatus.innerHTML = '<p class="sls-count">Standort konnte nicht ermittelt werden. Bitte Ort oder PLZ eingeben.</p>';
      }, { enableHighAccuracy: false, timeout: 8000, maximumAge: 60000 });
    });
  }

  /* Falls Leaflet (CDN) noch nicht bereit war: nach vollständigem Laden Karte nachziehen; scheitert das CDN, Karte ausblenden. */
  window.addEventListener('load', function () {
    if (!map) { initMap(); if (map) { updateMap(lastList); } else if (elMap) { elMap.style.display = 'none'; } }
    else { map.invalidateSize(); }
  });

  apply();
})();
